export const enum Sources {
  Cargowise = "cw",
  GoFreight = "gf",
}
